"use client";

import { useSyncExternalStore } from "react";

/**
 * Le libellé de la touche de raccourci — `⌘` sur Mac, `Ctrl` ailleurs.
 *
 * Lu par `useSyncExternalStore` et jamais pendant le rendu : `navigator`
 * n'existe pas sur le serveur, et le lire directement dans le JSX faisait
 * échouer le rendu serveur de **tout l'arbre** (`navigator is not defined`),
 * pas seulement de ce panneau — React abandonne alors le HTML et repasse la
 * page entière en client.
 *
 * L'instantané serveur vaut `Ctrl`, ce que React rend aussi pendant
 * l'hydratation avant d'adopter la vraie valeur. C'est ce qui évite à la fois
 * l'avertissement de non-concordance et un `setState` dans un effet.
 *
 * Rien à souscrire : la plateforme ne change pas sous les pieds.
 */
function subscribe(): () => void {
  return () => {};
}

function read(): string {
  return navigator.platform.includes("Mac") ? "⌘" : "Ctrl";
}

function readOnServer(): string {
  return "Ctrl";
}

export function useModifierKey(): string {
  return useSyncExternalStore(subscribe, read, readOnServer);
}
